import TableView from "./TableView";
import '../../styles/schedule.css'
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { ChangeEvent, useState } from "react";
import ListView from "./ListView";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { ProfileStudent } from "../../Utils/DataType";
import LockPage from "../../components/LockPage";

export default function Schedule() {
    let auth = useSelector<RootState, boolean>(state => state.auth);
    const [option, setOption] = useState<number>(0);
    const [optionType, setOptionType] = useState<number>(0);

    function onChangeOption(event: SelectChangeEvent<number>) {
        let value: string = `${event.target.value}`;
        setOption(parseInt(value));
    }
    function onChangeOptionType(event: SelectChangeEvent<number>) {
        let value: string = `${event.target.value}`;
        setOptionType(parseInt(value));
    }
    return (
        <div className="page schedule-page">
            <div className="page-main-veritcal">
                <div className="page-title home-title w-6/6">Thời khóa biểu</div>
                {auth && (
                    <>
                        {/* <div className="w-full flex gap-12">
                            <div className="schedule-option mt-6 w-2/5">
                                <FormControl fullWidth >
                                    <InputLabel>Học kỳ</InputLabel>
                                    <Select
                                        value={option}
                                        label="Học kỳ"
                                        size="small"
                                        onChange={onChangeOption}
                                    >
                                        <MenuItem value={0}>Học kỳ 1 năm học 2022 - 2023</MenuItem>
                                        <MenuItem value={1}>Học kỳ 2 năm học 2022 - 2023</MenuItem>
                                    </Select>
                                </FormControl>

                            </div>
                            <div className="schedule-option mt-6 w-2/5">
                                <FormControl fullWidth >
                                    <InputLabel>Thời khóa biểu</InputLabel>
                                    <Select
                                        value={optionType}
                                        label="Thời khóa biểu"
                                        size="small"
                                        onChange={onChangeOptionType}
                                    >
                                        <MenuItem value={0}>Thời khóa biểu học kỳ</MenuItem>
                                        <MenuItem value={1}>Thời khóa biểu tuần</MenuItem>
                                    </Select>
                                </FormControl>

                            </div>
                        </div> */}
                        {optionType ? <div className="schedule-table mt-4"> <TableView /></div> : <div className="schedule-table mt-4"><TableView /></div>}
                    </>
                )}
                {!auth && (<LockPage />)}
            </div>
        </div>
    )
}